import {Component, DestroyRef, inject, Input, OnInit} from '@angular/core';

import {CommonModule} from '@angular/common';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {LanguageService} from '@core/service/language.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Component({
  standalone: true,
  selector: 'tmw-translate-field',
  template: `{{ value }}`,
  imports: [CommonModule, TranslateModule],
})
export class TranslateFieldComponent implements OnInit {
  @Input() model!: any;
  @Input() field!: string;
  private readonly destroy: DestroyRef = inject(DestroyRef);
  value: string = '';

  constructor(private languageService: LanguageService) {}

  ngOnInit(): void {
    this.languageService.currentLang$.pipe(takeUntilDestroyed(this.destroy)).subscribe((lg: string) => this.updateTranslation(lg));
  }

  updateTranslation(lg: string) {
    this.value = lg == 'ar' ? this.model?.[`${this.field}Ar`] : this.model?.[this.field];
  }
}
